import React from 'react'

import styled from 'styled-components'

import { Hero, VideoPlayButton } from '../../Common'

export const VideoBlock = ({ pageBlock }) => {
    return (
        <Hero>
            <VideoPlayButton />
        </Hero>
    )
}